/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import PageHeader from '@/app/customComponents/PageHeader';
import { uploadFile } from '@/app/services/imageUpload/imageUpload';
import { addStaff } from '@/app/services/staff/staff';
import * as Actions from '@/app/store/actions';
import { getImageUrl, isImageFile } from '@/utils/utils';
import { Avatar, CircularProgress, Tooltip, Typography } from '@material-ui/core';
import GradientButton from '@shared/components/GradientButton';
import StyledInput from '@shared/components/StyledInput';
import StyledSelect from '@shared/components/StyledSelect';
import CloudUploadGradient from '@shared/icons/CloudUploadGradient';
import EditPhotoGradientIcon from '@shared/icons/EditPhotoGradientIcon';
import UploadPhotoGradientIcon from '@shared/icons/UploadPhotoGradientIcon';
import { useEffect, useRef, useState } from 'react';
import Dropzone from 'react-dropzone';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import './staff.css';
import { useNavigate } from 'react-router-dom';

const AddStaff = () => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const [selectedFile, setSelectedFile] = useState(null);
	const [preview, setPreview] = useState(null);
	const [attachFile, setAttachFile] = useState([]);
	const inputRef = useRef(null);
	const navigate = useNavigate();
	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm({
		defaultValues: {
			first_name: '',
			last_name: '',
			email: '',
			phone: '',
			emergency_phone: '',
			emergency_name: '',
			admin: 'yes',
			title: 'full-time',
			position_type: 'admin',
			date_of_birth: null,
			address: '',
			employment_date: null,
		},
	});

	useEffect(() => {
		if (!selectedFile) {
			setPreview(null);
			return;
		}
		const objectUrl = URL.createObjectURL(selectedFile);
		setPreview(objectUrl);
		return () => URL.revokeObjectURL(objectUrl);
	}, [selectedFile]);

	const onSelectFile = (e) => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(null);
			return;
		}
		const file = e.target.files[0];
		if (!isImageFile(file)) {
			dispatch(Actions.showMessage({ message: 'Please select an image file', variant: 'error' }));
		} else {
			setSelectedFile(e.target.files[0]);
		}
	};

	const removeItem = (index) => {
		setAttachFile(attachFile.filter((_, i) => i !== index));
	};

	const onSubmit = async (data) => {
		setIsLoading(true);
		try {
			const formData = { ...data };

			// format dates to YYYY-MM-DD
			if (formData.date_of_birth) {
				formData.date_of_birth = formData.date_of_birth.format('YYYY-MM-DD');
			}
			if (formData.employment_date) {
				formData.employment_date = formData.employment_date.format('YYYY-MM-DD');
			}

			if (selectedFile) {
				const filename = getImageUrl(selectedFile);
				let url = `${import.meta.env.VITE_S3_BASE_URL}`;
				url += await uploadFile(selectedFile, filename);
				formData.photo = url;
				formData.thumb = url;
			}

			if (attachFile.length > 0) {
				const upload_files = attachFile.map((e) => uploadFile(e, getImageUrl(e)));
				const uploaded = await Promise.all(upload_files);
				formData.document_urls = uploaded.map((url, i) => ({
					url: `${import.meta.env.VITE_S3_BASE_URL}${url}`,
					name: attachFile[i].name,
				}));
			}
			await addStaff(formData);
			dispatch(Actions.showMessage({ message: 'Staff added successfully', variant: 'success' }));
			navigate(-1);
		} catch (error) {
			dispatch(Actions.showMessage({ message: error.message || 'Error adding staff', variant: 'error' }));
		} finally {
			setIsLoading(false);
		}
	};

	const goBack = () => {
		navigate(-1);
	};

	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className=" mb-[162px] mx-60">
				<div className="flex justify-between items-end my-[40px]">
					<PageHeader onBack={goBack} title="Add Staff" />
				</div>
				<div className="bg-white rounded-3xl p-60 shadow-md">
					<div className="font-bold">
						<h1 className="text-[18px] ">Staff Information</h1>
					</div>
					<div className="mt-32 flex flex-col md:flex-row gap-32 md:gap-60 items-start">
						<div className="mx-auto md:mx-0">
							<button
								className="flex items-center gap-8 flex-col relative justify-self-center group"
								onClick={() => inputRef.current.click()}
								type="button"
							>
								{preview || control.photo ? (
									<>
										<Avatar className="w-[120px] h-[120px]" src={preview || control.photo} />
										<EditPhotoGradientIcon className="absolute bottom-0 right-0 w-32 h-32" />
									</>
								) : (
									<>
										<div className="w-[120px] h-[120px] grid grid-cols-8 rounded-full overflow-hidden group-hover:opacity-70 transition-all duration-300 group-active:shadow-md">
											{Array.from({ length: 64 }).map((_, index) => (
												<div
													className={`w-full h-full ${
														Math.floor(index / 8) % 2 === index % 2 ? 'bg-gray-300' : 'bg-gray-200'
													}`}
													key={index}
												/>
											))}
										</div>
										<UploadPhotoGradientIcon className="absolute bottom-0 right-0 w-32 h-32" />
									</>
								)}
							</button>
							<input accept="image/*" onChange={onSelectFile} ref={inputRef} style={{ display: 'none' }} type="file" />
						</div>
						<div className="flex flex-col gap-36 w-full mt-32">
							<div
								className="grid gap-40 gap-y-60"
								style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))' }}
							>
								<Controller
									control={control}
									name="first_name"
									render={({ field }) => (
										<StyledInput
											{...field}
											error={!!errors.first_name}
											helperText={errors.first_name?.message}
											label="First Name"
											placeholder="Enter first name"
										/>
									)}
									rules={{ required: 'First name is required' }}
								/>
								<Controller
									control={control}
									name="last_name"
									render={({ field }) => (
										<StyledInput
											{...field}
											error={!!errors.last_name}
											helperText={errors.last_name?.message}
											label="Last Name"
											placeholder="Enter last name"
										/>
									)}
									rules={{ required: 'Last name is required' }}
								/>
								<Controller
									control={control}
									name="email"
									render={({ field }) => (
										<StyledInput
											{...field}
											error={!!errors.email}
											helperText={errors.email?.message}
											label="Email"
											placeholder="Enter email"
											type="email"
										/>
									)}
									rules={{
										required: 'Email is required',
										pattern: {
											value: /^\S+@\S+\.\S+$/,
											message: 'Please enter a valid email',
										},
									}}
								/>
								<Controller
									control={control}
									name="phone"
									render={({ field }) => (
										<StyledInput
											{...field}
											error={!!errors.phone}
											helperText={errors.phone?.message}
											label="Phone"
											placeholder="Enter phone number"
											type="phone"
										/>
									)}
									rules={{
										validate: {
											length: (value) =>
												!value || // Allow empty, but validate if not
												value.replace(/\D/g, '').length >= 10 ||
												'Please enter a valid phone number',
										},
									}}
								/>
								<Controller
									control={control}
									name="emergency_name"
									render={({ field }) => (
										<StyledInput
											{...field}
											error={!!errors.emergency_name}
											helperText={errors.emergency_name?.message}
											label="Emergency Contact Name"
											placeholder="Enter emergency contact name"
										/>
									)}
								/>
								<Controller
									control={control}
									name="emergency_phone"
									render={({ field }) => (
										<StyledInput
											{...field}
											error={!!errors.emergency_phone}
											helperText={errors.emergency_phone?.message}
											label="Emergency Phone"
											placeholder="Enter emergency phone number"
											type="phone"
										/>
									)}
									rules={{
										validate: {
											length: (value) =>
												!value || // Allow empty, but validate if not
												value.replace(/\D/g, '').length >= 10 ||
												'Please enter a valid phone number',
										},
									}}
								/>
								<Controller
									control={control}
									name="position_type"
									render={({ field }) => (
										<StyledSelect
											{...field}
											error={!!errors.position_type}
											helperText={errors.position_type?.message}
											label="Position"
											options={[
												{ value: 'lead', label: 'Lead' },
												{ value: 'assistant', label: 'Assistant' },
												{ value: 'admin', label: 'Admin' },
												{ value: 'cook', label: 'Cook' },
											]}
											placeholder="Select position"
										/>
									)}
								/>
								<Controller
									control={control}
									name="title"
									render={({ field }) => (
										<StyledSelect
											{...field}
											error={!!errors.title}
											helperText={errors.title?.message}
											label="Title"
											options={[
												{ value: 'full-time', label: 'Full-time' },
												{ value: 'part-time', label: 'Part-time' },
											]}
											placeholder="Select hours"
										/>
									)}
								/>
								<Controller
									control={control}
									name="admin"
									render={({ field }) => (
										<StyledSelect
											{...field}
											error={!!errors.admin}
											helperText={errors.admin?.message}
											label="Admin"
											options={[
												{ value: 'yes', label: 'Yes' },
												{ value: 'no', label: 'No' },
											]}
											placeholder="Select admin status"
										/>
									)}
								/>
								<Controller
									control={control}
									name="date_of_birth"
									render={({ field }) => {
										const { value } = field;
										return (
											<StyledInput
												{...field}
												error={!!errors.date_of_birth}
												helperText={errors.date_of_birth?.message}
												label="Date of Birth"
												placeholder="MM/DD/YYYY"
												type="date"
												value={value}
											/>
										);
									}}
								/>
								<Controller
									control={control}
									name="address"
									render={({ field }) => <StyledInput {...field} label="Address" placeholder="Enter address" />}
								/>
								<Controller
									control={control}
									name="employment_date"
									render={({ field }) => (
										<StyledInput
											{...field}
											error={!!errors.employment_date}
											helperText={errors.employment_date?.message}
											label="Employment Date"
											placeholder="MM/DD/YYYY"
											type="date"
										/>
									)}
								/>
							</div>
							<div className="col-span-2">
								<Typography className="mb-16 font-bold text-16">Upload Files</Typography>
								<Controller
									control={control}
									defaultValue={[]}
									name="attachments"
									render={({ field }) => (
										<>
											<Dropzone
												accept={['image/jpeg', 'image/png', 'application/pdf']}
												maxSize={2097152}
												multiple
												onDrop={(acceptedFiles, rejectedFiles) => {
													if (rejectedFiles.length > 0) {
														rejectedFiles.forEach(({ file, errors }) => {
															if (errors[0]?.code === 'file-too-large') {
																dispatch(
																	Actions.showMessage({
																		message: `${file.name} is too large. Max size is 2MB`,
																		variant: 'error',
																	})
																);
															} else {
																dispatch(
																	Actions.showMessage({
																		message: `${file.name} is not a valid file type`,
																		variant: 'error',
																	})
																);
															}
														});
													}

													setAttachFile((prev) => [...prev, ...acceptedFiles]);
													field.onChange(acceptedFiles);
												}}
												onError={(err) => {
													console.error('Dropzone error:', err);
												}}
											>
												{({ getRootProps, getInputProps }) => (
													<div
														{...getRootProps()}
														className="rounded p-36 md:p-24 text-center cursor-pointer flex flex-col items-center justify-center gap-12"
														style={{
															border: '1px solid transparent',
															borderRadius: '1rem',
															borderImage:
																'repeating-linear-gradient(45deg, #80bfff, #80bfff 4px, transparent 4px, transparent 8px) 1 round',
														}}
													>
														<input {...getInputProps()} />
														<CloudUploadGradient className="w-[60px]" />
														<div className="content flex-col items-center gap-12 hidden md:flex">
															<span>Drag & drop files here.</span>
															<div className="flex items-center gap-8">
																<div className="h-px w-64 bg-gray-200" />
																<span className="text-12 text-gray-600">OR</span>
																<div className="h-px w-64 bg-gray-200" />
															</div>
														</div>
														<GradientButton variant="blurple">Choose files</GradientButton>
													</div>
												)}
											</Dropzone>

											{/* File Previews */}
											{attachFile.length > 0 ? (
												<div className="grid grid-cols-[repeat(auto-fill,minmax(100px,1fr))] gap-16 mt-24">
													{attachFile.map((file, i) => (
														<Tooltip key={i} title={file.name}>
															<div className="relative group">
																<div className="aspect-square rounded-lg overflow-hidden border border-gray-200">
																	{file.type.startsWith('image/') ? (
																		<img
																			alt={file.name}
																			className="w-full h-full object-cover"
																			src={URL.createObjectURL(file)}
																		/>
																	) : (
																		<div className="w-full h-full flex items-center justify-center bg-gray-50">
																			<img alt="PDF" className="w-64" src="assets/images/pdf_thumbnail.png" />
																		</div>
																	)}
																</div>
																<button
																	className="absolute -top-2 -right-2 size-24 rounded-full bg-red-500 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
																	onClick={(e) => {
																		e.stopPropagation();
																		removeItem(i);
																	}}
																	type="button"
																>
																	×
																</button>
																<div className="mt-2 text-center text-sm text-gray-600 truncate">{file.name}</div>
															</div>
														</Tooltip>
													))}
												</div>
											) : null}
										</>
									)}
								/>
							</div>
						</div>
					</div>
					<div className="flex justify-center md:justify-end mt-40 gap-32">
						{isLoading ? (
							<CircularProgress size={35} />
						) : (
							<>
								<CustomButton id="cancel" onClick={() => navigate(-1)} variant="secondary" width="140px">
									Cancel
								</CustomButton>
								<CustomButton
									id="submit"
									onClick={handleSubmit(onSubmit)}
									type="submit"
									variant="primary"
									width="140px"
								>
									Submit
								</CustomButton>
							</>
						)}
					</div>
				</div>
			</div>
		</FuseAnimate>
	);
};

export default AddStaff;
